import { injectable, inject } from 'inversify';
import type {
  IEmailOutboundRepository,
  ListEmailsParams,
  ListEmailsResult,
} from '@/domain/repositories/IEmailOutboundRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListEmailsAction {
  constructor(
    @inject(TYPES.IEmailOutboundRepository) private repo: IEmailOutboundRepository
  ) {}

  async execute(params?: ListEmailsParams): Promise<ListEmailsResult> {
    return this.repo.list(params);
  }
}
